<template>
  <div
    v-if="
      dataPermission?.includes('CNPS_AGENCY_DETAIL') ||
      dataPermission?.includes('CNPS_AGENCY_UPDATE')
    "
  >
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ idAgency ? 'Cập nhật đại lý' : 'Tạo đại lý' }}</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="submitRequest()"
        >
          <i class="bx" :class="idAgency ? 'bx-save' : 'bx-add-to-queue'"></i>
          {{ idAgency ? 'Cập nhật' : 'Tạo mới' }}
        </button>
        <button type="button" class="btn font-medium btn-outline-secondary" @click="closeAdd()">
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="leadsEdit" class="card-body px-1 mt-2 row">
        <form class="col-md-6">
          <div
            style="
              border: 1px solid #e2e2e2;
              border-radius: 10px;
              box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
              padding: 1.5rem;
            "
          >
            <h1 class="form-inner-heading mb-1">Thông tin chung</h1>

            <ValidationProvider rules="required|minMaxName_2" vid="name" name="Tên đại lý">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Tên đại lý <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    :disabled="idAgency"
                    v-model="dataAdd.name"
                    type="text"
                    class="form-control"
                    placeholder="Tên đại lý"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <!-- Thay thế ValidationProvider cho mã đại lý -->
            <ValidationProvider
              rules="required|minMaxName_2|validateAgencyCode"
              vid="code"
              name="Mã đại lý"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Mã đại lý <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="input-group">
                    <input
                      :disabled="idAgency || loadCheck"
                      v-model="dataAdd.code"
                      type="text"
                      class="form-control"
                      placeholder="Mã đại lý"
                      @input="validateAgencyCodeInput"
                      @blur="convertToUpperCase"
                    />
                    <div class="input-group-append">
                      <button
                        style="width: 110px"
                        type="button"
                        class="btn btn-outline-primary"
                        @click="generateCode"
                        :disabled="idAgency"
                      >
                        <i class="bx bx-refresh"></i>
                        {{ loadCheck ? 'check...' : 'Tự động' }}
                      </button>
                    </div>
                  </div>
                  <p class="text-danger">{{ errors[0] }}</p>
                  <small class="form-text text-muted"
                    >Chỉ cho phép ký tự: a-z, A-Z, 0-9, _, #</small
                  >
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|email" vid="email" name="Email">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Email <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    v-model="dataAdd.email"
                    type="email"
                    class="form-control"
                    placeholder="Email"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|validatePhone" vid="mobile" name="Số điện thoại">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Số điện thoại <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    v-model="dataAdd.mobile"
                    type="text"
                    class="form-control"
                    placeholder="Số điện thoại"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="address" name="Địa chỉ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Địa chỉ <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    v-model="dataAdd.address"
                    type="text"
                    class="form-control"
                    placeholder="Địa chỉ"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="keeperId" name="Người phụ trách">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Người phụ trách <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataAdd.keeperId"
                    :options="dataManagers"
                    placeholder="Chọn người phụ trách"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="" vid="contractFiles" name="File hợp đồng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label">File hợp đồng</label>
                <div class="col-sm-9">
                  <div class="custom-file-upload">
                    <div
                      class="file-upload-wrapper"
                      :class="{
                        'has-file': dataAdd.contractFiles && dataAdd.contractFiles.length > 0,
                      }"
                      @click="$refs.fileInput.click()"
                    >
                      <div class="file-upload-info">
                        <i class="bx bx-cloud-upload mr-2" style="font-size: 24px"></i>
                        <span v-if="!dataAdd.contractFiles || dataAdd.contractFiles.length === 0"
                          >Chọn file hoặc kéo thả file vào đây</span
                        >
                        <span v-else>{{ dataAdd.contractFileName }}</span>
                      </div>
                    </div>
                    <input
                      ref="fileInput"
                      type="file"
                      class="d-none"
                      @change="handleFileUpload"
                      accept="application/pdf"
                    />
                    <div
                      v-if="dataAdd.contractFiles && dataAdd.contractFiles.length > 0"
                      class="file-details mt-2"
                    >
                      <div class="d-flex align-items-center">
                        <i class="bx bx-file mr-2" style="font-size: 18px"></i>
                        <span class="file-name">{{ dataAdd.contractFileName }}</span>
                        <!-- <span class="file-size ml-2"
                          >({{
                            formatFileSize(dataAdd.contractFileSize)
                          }})</span
                        > -->
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger ml-auto"
                          @click.stop="removeFile"
                        >
                          <i class="bx bx-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
        </form>
        <form class="col-md-6">
          <div
            style="
              border: 1px solid #e2e2e2;
              border-radius: 10px;
              box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
              padding: 1.5rem;
            "
          >
            <h1 class="form-inner-heading mb-1">Thông tin thanh toán</h1>

            <ValidationProvider rules="required" vid="accountNumberBank" name="STK ngân hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >STK ngân hàng <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    v-model="dataAdd.accountNumberBank"
                    type="text"
                    class="form-control"
                    placeholder="Số tài khoản ngân hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="accountNameBank" name="Người thụ hưởng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Người thụ hưởng <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <input
                    v-model="dataAdd.accountNameBank"
                    type="text"
                    class="form-control"
                    placeholder="Tên người thụ hưởng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="bankCode" name="Ngân hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Ngân hàng <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataAdd.bankCode"
                    :options="dataBanks"
                    placeholder="Chọn ngân hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <!-- <ValidationProvider
              rules="required"
              vid="receiveInvoice"
              name="Có nhận hóa đơn không"
            > -->
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Có nhận hóa đơn không </label>
              <div class="col-sm-9">
                <Select2
                  v-model="dataAdd.receiveInvoice"
                  :options="[
                    { id: true, text: 'Có' },
                    { id: false, text: 'Không' },
                  ]"
                  @change="toggleInvoiceFields"
                >
                </Select2>
              </div>
            </div>
            <!-- </ValidationProvider> -->

            <div v-if="dataAdd.receiveInvoice === 'true'">
              <ValidationProvider rules="required" vid="taxCode" name="Mã số thuế">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Mã số thuế <span style="color: red">*</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      v-model="dataAdd.taxCode"
                      type="text"
                      class="form-control"
                      placeholder="Mã số thuế"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="businessName" name="Tên DN">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Tên DN <span style="color: red">*</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      v-model="dataAdd.businessName"
                      type="text"
                      class="form-control"
                      placeholder="Tên doanh nghiệp"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider
                rules="required"
                vid="businessRegistrationAddress"
                name="Địa chỉ ĐKKD"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Địa chỉ ĐKKD <span style="color: red">*</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      v-model="dataAdd.businessRegistrationAddress"
                      type="text"
                      class="form-control"
                      placeholder="Địa chỉ đăng ký kinh doanh"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    v-if="isRouterList"
                    type="button"
                    class="btn btn-primary"
                    @click="closeAdd"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { CommonService } from '@/services/common.service'
  import { extend } from 'vee-validate'
  import {
    createAgency,
    updateAgency,
    checkCodeExists,
    UploadFile,
    DetailAgency,
  } from '@/services/agencty'
  import { StaffService } from '@/services/staff.service'
  import { BankService } from '@/services/bank.service'

  // Định nghĩa quy tắc validate cho số điện thoại
  extend('validatePhone', {
    validate(value) {
      // Kiểm tra có phải số điện thoại Việt Nam không
      const phoneRegex =
        /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/
      return phoneRegex.test(value)
    },
    message: 'Số điện thoại không đúng định dạng',
  })

  extend('validateAgencyCode', {
    validate(value) {
      // Kiểm tra mã đại lý chỉ chứa a-z, A-Z, 0-9, _, #
      const codeRegex = /^[a-zA-Z0-9_#]*$/
      return codeRegex.test(value)
    },
    message: 'Mã đại lý chỉ được chứa các ký tự: A-Z, a-z, 0-9, _, #',
  })

  export default {
    data() {
      return {
        dataAdd: {
          name: '',
          code: '',
          keeperId: '',
          email: '',
          mobile: '',
          address: '',
          accountNumberBank: '',
          accountNameBank: '',
          bankCode: '',
          receiveInvoice: false,
          taxCode: '',
          businessName: '',
          businessRegistrationAddress: '',
          contractFiles: [],
          contractFileName: '',
          contractFileSize: 0,
        },
        idAgency: this.$route.params.id,
        dataUser: JSON.parse(localStorage.getItem('userData')),

        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },

        messSuccess: '',
        messErr: '',

        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',

        // Dữ liệu cho các Select2
        dataManagers: [],
        dataBanks: [],
        dataRating: [],
        loadCheck: false,
        isRouterList: false,
      }
    },
    created() {
      this.configSystem()
      this.fetchData()
      this.loadSelectData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      // 2. Thêm phương thức xử lý sự kiện input để lọc ký tự không hợp lệ
      validateAgencyCodeInput(event) {
        // Chỉ cho phép a-z, A-Z, 0-9, _, #
        const regex = /[^a-zA-Z0-9_#]/g
        this.dataAdd.code = this.dataAdd.code.replace(regex, '')

        // Tự động chuyển đổi thành chữ hoa khi nhập
        this.dataAdd.code = this.dataAdd.code.toUpperCase()
      },

      // 3. Thêm phương thức chuyển đổi sang chữ hoa khi blur
      convertToUpperCase() {
        this.dataAdd.code = this.dataAdd.code.toUpperCase()
      },
      async closeAdd() {
        this.$router.push('/list-agency')
      },

      async codeExists(code) {
        this.loadCheck = true
        try {
          const response = await checkCodeExists(code)
          return response.result // Giả sử API trả về {exists: true/false}
        } catch (error) {
          return false
        } finally {
          this.loadCheck = false
        }
      },

      async generateCode() {
        try {
          // Tạo phần ngẫu nhiên của mã, chỉ sử dụng các ký tự hợp lệ (A-Z, 0-9, _)
          const timestamp = new Date().getTime()
          const randomPart = Math.floor(Math.random() * 10000)
            .toString()
            .padStart(4, '0')

          // Kết hợp để tạo mã duy nhất, sử dụng dấu gạch dưới thay vì dấu gạch ngang
          const newCode = `CODE_${timestamp.toString().slice(-6)}${randomPart}`

          // Kiểm tra xem mã đã tồn tại chưa
          const exists = await this.codeExists(newCode)

          if (!exists) {
            // Nếu mã đã tồn tại, hiển thị thông báo lỗi
            this.showErr('Mã đại lý đã tồn tại trong hệ thống. Vui lòng thử lại.')
            return
          }

          // Nếu mã chưa tồn tại, cập nhật giá trị
          this.dataAdd.code = newCode
        } catch (error) {
          this.showErr('Có lỗi xảy ra khi tạo mã đại lý. Vui lòng thử lại.')
        }
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              console.log('data system', data.data)
            }
          })
          .catch(error => console.log(error))
      },

      async fetchData() {
        try {
          // Kiểm tra nếu có id thì load dữ liệu để cập nhật
          if (this.idAgency) {
            this.loading = true
            // Giả định có API loadAgencyById
            const response = await DetailAgency(this.idAgency)
            if (response.code === 1000) {
              const agencyData = response.data || {}

              // Cập nhật dataAdd với dữ liệu từ API
              this.dataAdd = {
                name: agencyData.name || '',
                code: agencyData.code || '',
                keeperId: agencyData.keeperId || '',
                email: agencyData.email || '',
                mobile: agencyData.mobile || '',
                address: agencyData.address || '',
                accountNumberBank: agencyData.accountNumberBank || '',
                accountNameBank: agencyData.accountNameBank || '',
                bankCode: agencyData.bankCode || '',
                receiveInvoice: String(agencyData.receiveInvoice) || 'false',
                taxCode: agencyData.taxCode || '',
                businessName: agencyData.businessName || '',
                businessRegistrationAddress: agencyData.businessRegistrationAddress || '',
                contractFiles: agencyData.contractFiles || [],
                contractFileName:
                  agencyData.contractFiles && agencyData.contractFiles.length > 0
                    ? agencyData.contractFiles[0]
                    : '',
                contractFileSize: 0, // Không có thông tin size từ API
              }

              // Nếu có file hợp đồng, cập nhật UI
              if (this.dataAdd.contractFiles && this.dataAdd.contractFiles.length > 0) {
                this.dataAdd.contractFileName = this.dataAdd.contractFiles[0]
              }
            } else {
              this.showErr('Không tìm thấy thông tin đại lý')
            }
            this.loading = false
          }
        } catch (error) {
          console.log(error)
          this.loading = false
          this.showErr('Có lỗi xảy ra khi tải dữ liệu')
        }
      },

      async loadSelectData() {
        try {
          const userRes = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (userRes.code === 1000) {
            this.dataManagers = userRes.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
          }
          const bankRes = await BankService.listBank()
          if (bankRes.code === 1000) {
            this.dataBanks = bankRes.data.map(e => {
              return {
                id: e.bankCode,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      toggleInvoiceFields() {
        // Reset các trường liên quan đến hóa đơn nếu chọn "Không"
        if (this.dataAdd.receiveInvoice === 'false') {
          this.dataAdd.taxCode = ''
          this.dataAdd.businessName = ''
          this.dataAdd.businessRegistrationAddress = ''
        }
      },

      handleFileUpload(event) {
        // Xử lý upload file
        const file = event.target.files[0]
        if (file) {
          // Lưu thông tin file
          this.dataAdd.fileToUpload = file
          this.dataAdd.contractFiles = [file.name]
          this.dataAdd.contractFileName = file.name
          this.dataAdd.contractFileSize = file.size
        }
      },

      removeFile() {
        this.dataAdd.contractFiles = []
        this.dataAdd.contractFileName = ''
        this.dataAdd.contractFileSize = 0
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },

      formatFileSize(size) {
        if (size < 1024) {
          return size + ' bytes'
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(2) + ' KB'
        } else {
          return (size / (1024 * 1024)).toFixed(2) + ' MB'
        }
      },
      async uploadFileToServer() {
        // Kiểm tra xem có file cần upload không
        if (!this.dataAdd.fileToUpload) {
          return this.dataAdd.contractFiles
        }

        try {
          // Tạo FormData và gửi file lên server
          const formData = new FormData()
          formData.append('files', this.dataAdd.fileToUpload)
          formData.append('folderName', 'NextCrm')

          const response = await UploadFile(formData)

          if (response.code === 1000) {
            // Trả về chuỗi URL từ API
            return response.data
          } else {
            throw new Error(response.message || 'Tải file thất bại')
          }
        } catch (error) {
          console.error('Lỗi khi tải file:', error)
          throw error
        }
      },

      async submitRequest() {
        // Xử lý lưu dữ liệu
        try {
          this.loading = true
          const valid = await this.$refs.leadsEdit.validate()
          if (!valid) {
            this.showErr('Vui lòng điền đầy đủ thông tin bắt buộc')
            this.loading = false
            return
          }
          const file = await this.uploadFileToServer()
          // Tạo payload dữ liệu từ model
          const payload = {
            name: this.dataAdd.name,
            code: this.dataAdd.code,
            keeperId: this.dataAdd.keeperId,
            email: this.dataAdd.email,
            mobile: this.dataAdd.mobile,
            address: this.dataAdd.address,
            accountNumberBank: this.dataAdd.accountNumberBank,
            accountNameBank: this.dataAdd.accountNameBank,
            bankCode: this.dataAdd.bankCode,
            receiveInvoice: this.dataAdd.receiveInvoice === 'true',
            taxCode: this.dataAdd.taxCode,
            businessName: this.dataAdd.businessName,
            businessRegistrationAddress: this.dataAdd.businessRegistrationAddress,
            contractFiles: file || [],
          }
          // Xác định nếu là tạo mới hay cập nhật dựa vào idAgency
          let response
          if (this.idAgency) {
            // Cập nhật đại lý đã tồn tại
            payload.id = this.idAgency
            response = await updateAgency(payload)
            if (response.code === 1000) {
              this.isRouterList = true
              this.showSuccess('Cập nhật đại lý thành công')
            } else {
              this.showErr(response.message || 'Cập nhật thất bại')
              this.isRouterList = false
            }
          } else {
            // Tạo đại lý mới
            response = await createAgency(payload)
            if (response.code === 1000) {
              this.isRouterList = true
              this.showSuccess('Tạo đại lý thành công')
            } else {
              this.showErr(response.message || 'Tạo đại lý thất bại')
              this.isRouterList = false
            }
          }
        } catch (error) {
          this.loading = false
          this.showErr(
            error.message || error.data.response.message || 'Có lỗi xảy ra, vui lòng thử lại'
          )
          this.isRouterList = false
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
        this.keyCheck = 'error'
      },

      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
        this.keyCheck = 'success'
      },
    },
  }
</script>
<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .custom-file-upload {
    width: 100%;
  }

  .file-upload-wrapper {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    background-color: #f9f9f9;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .file-upload-wrapper:hover {
    border-color: #007bff;
    background-color: #f0f7ff;
  }

  .file-upload-wrapper.has-file {
    border-color: #28a745;
    background-color: #f0fff4;
  }

  .file-upload-info {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
  }

  .file-details {
    background: rgba(40, 167, 69, 0.1);
    border: 1px solid rgba(40, 167, 69, 0.2);
    border-radius: 4px;
    padding: 8px 12px;
  }

  .file-name {
    font-weight: 500;
    color: #343a40;
  }

  .file-size {
    color: #6c757d;
    font-size: 0.85rem;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .modal-dialog {
    margin: 0;
    max-width: 500px;
    width: 90%;
  }

  /* Hiệu ứng chuyển động cho modal */
  .modal-enter-active,
  .modal-leave-active {
    transition: opacity 0.3s;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;
  }
</style>
